module.exports = __webpack_public_path__ + "static/media/diet_selected.3093e11f.svg";